import HsocCreditsExplainer from 'pricing-pages-ui-components/hsoc-credits-explainer/HsocCreditsExplainer';
import { useCallback } from 'react';
import { useTrackSectionViewed } from '../../hooks/useTrackSectionViewed';
import { HSOC_V2_SCREEN, TRACKING_SOURCES, trackClickedLink, trackImageInteraction } from '../../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
const trackingSource = TRACKING_SOURCES.CREDITS_EXPLAINER;
const DEFAULT_AGENTS = ['customer', 'prospecting', 'data'];
export const HsocCreditsExplainerSection = () => {
  const sectionRef = useTrackSectionViewed(trackingSource, HSOC_V2_SCREEN);
  const handleLinkClick = useCallback(props => {
    trackClickedLink(Object.assign({}, props, {
      trackingSource,
      screen: HSOC_V2_SCREEN
    }));
  }, []);
  const handleCarouselClick = useCallback((index, direction) => {
    var _DEFAULT_AGENTS$index;
    trackImageInteraction({
      action: direction === 'next' ? 'clicked-carousel-next' : 'clicked-carousel-previous',
      name: (_DEFAULT_AGENTS$index = DEFAULT_AGENTS[index]) !== null && _DEFAULT_AGENTS$index !== void 0 ? _DEFAULT_AGENTS$index : '',
      trackingSource,
      screen: HSOC_V2_SCREEN
    });
  }, []);
  const handleCarouselScroll = useCallback((index, direction) => {
    var _DEFAULT_AGENTS$index2;
    trackImageInteraction({
      action: direction === 'next' ? 'swiped-carousel-next' : 'swiped-carousel-previous',
      name: (_DEFAULT_AGENTS$index2 = DEFAULT_AGENTS[index]) !== null && _DEFAULT_AGENTS$index2 !== void 0 ? _DEFAULT_AGENTS$index2 : '',
      trackingSource,
      screen: HSOC_V2_SCREEN
    });
  }, []);
  return /*#__PURE__*/_jsx("div", {
    ref: sectionRef,
    children: /*#__PURE__*/_jsx(HsocCreditsExplainer, {
      agents: DEFAULT_AGENTS,
      onLinkClick: handleLinkClick,
      onCarouselClick: handleCarouselClick,
      onCarouselScroll: handleCarouselScroll
    })
  });
};
export default HsocCreditsExplainerSection;